import React, { Component } from 'react'
import { Link } from 'react-router'
import { HeaderView } from '@merchant-backend/common-components'
import Intro from './Intro'
import SearchBar from './SearchBar'
import List from './List'
import DetailModal from './Modal/Detail'
import ApplyModal from './Modal/Apply'
import { MARKETING_CENTER_PATH } from '@constant'

export default class extends Component {
  render() {
    const header = [
      <Link to={MARKETING_CENTER_PATH}>支付订单</Link>,
      '开票申请'
    ]

    return (
      <HeaderView header={header} title="开票申请">
        <Intro />
        <SearchBar />
        <List />

        <DetailModal />
        <ApplyModal />
      </HeaderView>
    )
  }
}
